import '../template_legal/template_legal.css'
import './template_legal_summary.css'
